// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponPatientPatientSearchPatientSearchResponse {
    static getAttributeTypeMap() {
        return CouponPatientPatientSearchPatientSearchResponse.attributeTypeMap;
    }
}
CouponPatientPatientSearchPatientSearchResponse.discriminator = undefined;
CouponPatientPatientSearchPatientSearchResponse.additionalProperties = false;
CouponPatientPatientSearchPatientSearchResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtEnrollmentPatientSearchResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=couponPatientPatientSearchPatientSearchResponse.js.map